import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../lib/constants';
import axios from 'axios';

interface UserDropdownProps {
  username: string;
}

const UserDropdown: React.FC<UserDropdownProps> = ({ username }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <span
        style={{ color: '#000', fontWeight: 600, cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setOpen(o => !o)}
      >
        {username} &#x25BC;
      </span>
      {open && (
        <div style={{ position: 'absolute', right: 0, top: 'calc(100% + 8px)', background: '#fff', border: '1px solid #ddd', borderRadius: 6, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', minWidth: 140, zIndex: 200 }}>
          <Link to="/current-user" style={{ display: 'block', padding: '10px 16px', color: '#222', textDecoration: 'none', fontWeight: 500 }}>User Info</Link>
          <button
            style={{ display: 'block', width: '100%', padding: '10px 16px', color: '#222', background: 'none', border: 'none', textAlign: 'left', fontWeight: 500, cursor: 'pointer' }}
            onClick={async () => {
              const refresh = localStorage.getItem('refresh');
              try {
                if (refresh) {
                  await axios.post(`${API_BASE_URL}/api/logout/`, { refresh });
                }
              } catch (e) {
                // Ignore errors when logging out
              }
              localStorage.removeItem('token');
              localStorage.removeItem('refresh');
              window.location.href = '/login';
            }}
          >Logout</button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
